/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  return {
    variables: {
      patient_id: props.patientId ?? null,
      search_from_patient: Boolean(props.patientId),
      appointment_booking_id: props.appointmentBookingId ?? null,
      search_from_booking: Boolean(props.appointmentBookingId),
    },
    pause: !props.patientId && !props.appointmentBookingId,
    requestPolicy: 'cache-and-network',
  }
}
